import { jsx as e } from "react/jsx-runtime";
import { cn as i, sharePropsWithChildren as n } from "@tameeni/shared-logic";
import { ActionButton as f, Actions as m, HeroContent as p, Selections as x } from "./hero-content/index.js";
import { MediaSection as b } from "./hero-media.js";
import { Option as v } from "./hero-content/hero-option.js";
function c({
  locale: r,
  children: o,
  className: t
}) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: i(
        "relative bg-blue-100 border-y border-slate-100 overflow-hidden",
        t
      ),
      children: /* @__PURE__ */ e("div", { className: "box flex flex-col-reverse justify-between lg:flex-row gap-6 lg:items-center", children: n({
        children: o,
        sharedProps: {
          locale: r
        }
      }) })
    }
  );
}
export {
  f as ActionButton,
  m as Actions,
  p as HeroContent,
  b as MediaSection,
  v as Option,
  x as Selections,
  c as default
};
//# sourceMappingURL=index.js.map
